export function arrayToUrlSegment(arr: string[], prefix: string): string {
	if (arr.length === 0) return "";
	return `${prefix}-${arr.join("-")}`;
}
